// AI Generated Component
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-no-follow',
    standalone: false,
    template: `
        <h5>{{ getTranslatedTitle() }}</h5>
        <ol>
            <li *ngFor="let follow of seo.content; trackBy: trackByIndex">{{ follow }}</li>
        </ol>
    `,
})
export class SeoInformationNoFollowComponent {
    @Input() seo: any;

    count (content: any): number {
        if (Array.isArray(content)) {
            return content.length;
        } else if (content === null || content === undefined) {
            return 0;
        }

        return 1;
    }

    getTranslatedTitle (): string {
        const count = this.count(this.seo?.content);
        if (count === 1) {
            return 'There is one link with no follow on this page';
        }
        return `There are ${count} links with no follow on this page`;
    }

    trackByIndex (index: number): number {
        return index;
    }
}
